<template>
<loader v-bind="{ loading }">
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Distribution</th>
        <th class="is-narrow">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="distribution in vulnerability.distributions" :key="distribution.id">
        <td>{{ distribution.name }}</td>
        <td>
          <action-button @click="removeDistribution(distribution)" class="is-small is-rounded is-danger">
            <icon icon="trash"/>
          </action-button>
        </td>
      </tr>
    </tbody>
  </table>
</loader>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  data: () => ({
    loading: true
  }),

  beforeCreate() {
    this.$store.dispatch('vulnerability/loadDistributions', this.$route.params.vulnerability).then(() => {
      this.loading = false
    })
  },

  methods: {
    removeDistribution(distribution) {
      this.$store.dispatch('vulnerability/removeDistribution', {
        distribution: distribution.id,
        vulnerability: this.vulnerability.id
      }).then(() => {

      }).catch(error => {

      })
    }
  },

  computed: {
    ...mapGetters('vulnerability', [
      'vulnerability'
    ])
  }
}
</script>